import { render, staticRenderFns } from "./NewSalesModal.vue?vue&type=template&id=62526e34&"
import script from "./NewSalesModal.vue?vue&type=script&lang=js&"
export * from "./NewSalesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports